var map = {
	"./account.svg": 8556,
	"./arrow.svg": 6383,
	"./basket.svg": 8753,
	"./check.svg": 9345,
	"./chevron.svg": 6162,
	"./close.svg": 6386,
	"./facebook.svg": 150,
	"./info.svg": 8782,
	"./instagram.svg": 4121,
	"./linkedin.svg": 5933,
	"./menu.svg": 9351,
	"./search.svg": 275,
	"./triangle.svg": 7549,
	"./twitter.svg": 1365,
	"./webatvantage.svg": 1613,
	"./x.svg": 2643,
	"./youtube.svg": 4401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4683;